var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { useAtomValue } from 'jotai';
import { useLoaderData } from 'react-router';
import { availableLanguages } from "../../../../../../../shared/language";
import { Table, Button } from "../../../../../Components/UI";




import { Translate } from "../../../../../../I18N";
import { templatesAtom } from "../../../../../atoms";
import { TableTitle } from "../TableTitle";
import { PXTableFooter } from "../PXTableFooter";
import { tableBuilder } from "./TableElements";








const ParagraphsTable = ({
  pxParagraphData,
  viewParagraph,
  totalRows,
  openPDFSidepanel
}) => {var _availableLanguages$f;
  const templates = useAtomValue(templatesAtom);
  const { extractor } = useLoaderData();

  const languages =
  pxParagraphData.length > 0 ?
  [
  {
    _id: pxParagraphData[0]._id,
    name:
    ((_availableLanguages$f = availableLanguages.find((lang) => lang.key === pxParagraphData[0].language)) === null || _availableLanguages$f === void 0 ? void 0 : _availableLanguages$f.label) ||
    ''
  },
  ...(pxParagraphData[0].subRows || []).map((subRow) => {var _availableLanguages$f2;return {
      _id: subRow._id,
      name:
      ((_availableLanguages$f2 = availableLanguages.find((lang) => lang.key === subRow.language)) === null || _availableLanguages$f2 === void 0 ? void 0 : _availableLanguages$f2.localized_label) || ''
    };})] :

  [];

  const template = templates.find((temp) => temp._id === (extractor === null || extractor === void 0 ? void 0 : extractor.sourceTemplateId));
  return (/*#__PURE__*/
    _jsx(Table, {
      data: pxParagraphData,
      columns: tableBuilder({ onViewAction: viewParagraph }),
      header: /*#__PURE__*/_jsx(TableTitle, { items: [template, ...languages] }),
      actions: /*#__PURE__*/
      _jsx(Button, {
        onClick: () => openPDFSidepanel(true),
        styling: "light",
        className: "flex items-center gap-2 leading-4 text-gray-800" }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Open PDF")
      ),

      footer: /*#__PURE__*/_jsx(PXTableFooter, { total: totalRows, currentDataLength: pxParagraphData.length }),
      groupColumnPosition: 3 }
    ));

};

export { ParagraphsTable };